export default __webpack_public_path__ + "static/intro_elements_A2_desktop-bd5b1e6bcd987c5755fa185cbe8673d5.jpg";